/** List/detail include `storeId` for each item (proxy `ProductItem.storeId: String!`). */
export const getProductItemListQuery = `
  query ListProductItems($input: ListProductItemsInput!) {
    listProductItemsByProduct(input: $input) {
      code
      totalElements
      totalPages
      currentPage
      pageSize
      items {
        id
        productId
        companyId
        storeId
        totalQuantity
        remainingQuantity
        reservedQuantity
        state
        variationName
        lotNumber
        purchasePrice
        price
        minSalesPrice
        expirationDate
        productionDate
        weight
        height
        width
        thickness
        color
        material
        packagingType
        packSize
        createdBy
        createdAt
        updatedBy
        updatedAt
      }
    }
  }
`;

export const getProductItemDetailQuery = `
  query GetProductItemDetail($input: GetProductItemDetailInput!) {
     getProductItemDetail(input: $input) {
      code
      item {
        id
        productId
        companyId
        storeId
        totalQuantity
        remainingQuantity
        reservedQuantity
        state
        variationName
        lotNumber
        purchasePrice
        price
        minSalesPrice
        expirationDate
        productionDate
        weight
        height
        width
        thickness
        color
        material
        packagingType
        packSize
        createdBy
        createdAt
        updatedBy
        updatedAt
      }
    }
  }
`;

export const transitionProductItemQuery = `
  mutation TransitionProductItem($input: ProductItemTransitionInput!) {
      transitionProductItem(input: $input) {
      code
    }
  }
`;

export const createProductItemQuery = `
  mutation CreateProductItem($input: CreateProductItemInput!) {
    createProductItem(input: $input) {
      code
      id
    }
  }
`;

export const updateProductItemQuery = `
  mutation UpdateProductItem($input: UpdateProductItemInput!) {
    updateProductItem(input: $input) {
      code
      id
    }
  }
`;

export const deleteProductItemQuery = `
  mutation DeleteProductItem($input: DeleteProductItemInput!) {
    deleteProductItem(input: $input) {
      code
    }
  }
`;
